module.exports = __webpack_public_path__ + "img/banner.8280b570.jpg";